import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  counterUnseenMessages = null,
  title = '',
  color = 'white',
  fullWidth = false,
  textAlign = 'center',
  border = true,
  icon = false,
  iconSrc,
  iconPosition = '',
  customProps = {},
  buttonStyles = '',
  onClick = () => {},
}) => {
  const colors = {
    white: 'bg-white text-grey-darkest',
    greyLight: 'bg-grey-4 text-black',
    blue: 'bg-blue text-white',
    orange: 'bg-orange text-white',
    green: 'bg-green text-white',
    purple: 'bg-purple text-white',
    red: 'bg-red text-white',
    gray: 'bg-black text-white',
  };

  return (
    <button
      className={`
        border 
        rounded
        py-3 
        px-6
        text-${textAlign}
        ${fullWidth ? 'block w-full' : ''}
        ${colors[color] ? colors[color] : 'bg-white text-black'}
        ${border && color === 'white' ? 'border-grey-dark' : `border-${color}`}
        ${customProps.disabled ? 'opacity-50 pointer-events-none' : ''}
        ${buttonStyles}
      `}
      {...customProps}
      onClick={onClick}>
      {counterUnseenMessages && (
        <span
          className="absolute flex justify-center items-center w-5 h-5 bg-purple text-12 text-white font-medium rounded-full"
          style={{top: -15, right: -5}}>
          {counterUnseenMessages}
        </span>
      )}
      <div
        className={`
                ${icon ? 'flex' : 'inline-block'}
                ${
                  iconPosition === 'left'
                    ? 'flex-row'
                    : title
                      ? ' flex-row-reverse'
                      : 'flex-row-reverse -ml-3'
                }
                items-center
                pointer-events-none
            `}>
        {!!icon && iconSrc}
        <span
          className={`flex-grow ${iconPosition === 'left' ? 'ml-1' : icon ? 'mr-1' : ''}`}>
          {title}
        </span>
      </div>
    </button>
  );
};

Button.propTypes = {
  counterUnseenMessages: PropTypes.number,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
  textAlignment: PropTypes.string,
  border: PropTypes.bool,
  icon: PropTypes.bool,
  iconPosition: PropTypes.string,
  customProps: PropTypes.object,
  onClick: PropTypes.func,
};

export default Button;
